export default __webpack_public_path__ + "static/2-1d378ed489e0c855ed149bb42976ab82.jpeg";